import { PayloadAction } from '@reduxjs/toolkit';

import { State } from '../types/state';

const setCanUseRestrictions = (
  state: State,
  action: PayloadAction<boolean>,
) => {
  state.canUseRestrictions = action.payload;
};

export default setCanUseRestrictions;
